import { fetchData } from '@stocker/codegen/helpers'

export const fetchVendure = <TData, TVariables>(
  query: string,
  variables?: TVariables,
  options?: RequestInit['headers'],
): (() => Promise<TData>) => {
  const headers: Record<string, string> = {
    ...options as Record<string, string>,
  }

  const baseUrl = process.env.NEXT_PUBLIC_VENDURE_GRAPHQL_API_URL!

  return fetchData(baseUrl, query, variables, headers)
}
